import { Box } from "@mui/material"
import { makeStyles } from "makeStyles"
import RatingStars from "../../../components/RatingStars"

const useStyles = makeStyles()((theme) => ({
	responsiveFont: {
		padding: "0",
		margin: "0",
		fontSize: "1rem",
		display: "flex",
		[theme.breakpoints.down("md")]: {
			fontSize: "0.8rem",
			display: "flex",
		},
	},
}))

const RatingPrintCompare = ({ averageRating = 0 }: Props) => {
	const { classes } = useStyles()

	return (
		<div className={classes.responsiveFont}>
			{averageRating ? (
				<Box mr={2} style={{ display: "flex", alignItems: "center" }}>
					<RatingStars rating={averageRating} fontSize="small" />
				</Box>
			) : null}

			{/*

				<Box mr={2} style={{ display: "flex", alignItems: "center" }}>
					<Box mr={1}>
						<Icon path={mdiPrinterSettings} size={0.8} />
					</Box>
					<div>Drucken</div>
				</Box>
			
				<Box style={{ display: "flex", alignItems: "center" }}>
					<Box mr={1}>
						<Icon path={mdiCompare} size={0.8} />
					</Box>
					<div>Artikel vergleichen</div>
				</Box>

			*/}
		</div>
	)
}

interface Props {
	averageRating: number
}

export default RatingPrintCompare
